import { HelpCircle } from 'lucide-react';
import POSSelectField from '../../POS/Fields/POSSelectField';
import POSCustomerField from '../../POS/Fields/POSCustomerField';
import POSDateField from '../../POS/Fields/POSDateField';
import POSToolbarButton from '../../POS/Fields/POSToolbarButton';
import POSCreditNoteInfo from './POSCreditNoteInfo';

interface Props {
  form: any;
  formErrors: any;

  branchDropdown: any[];
  canPickBranch: boolean;
  customersDropdown: any[];
  allowedDocumentTypes: any[];

  updateField: (field: string, value: any) => void;

  handlerUpdateSaleHeader: (form: any, id: number) => void;

  handlerGenerateSale: (form: any) => void;

  handlerResetSaleFormOnly: () => void;

  isSubmitting: boolean;

  reloadCustomersDropdown: () => void;

  saveCustomerQuick?: () => Promise<void> | void;

  isCreditNote?: boolean;

  showCustomerModal?: boolean;

  openCustomerModal?: () => void;

  closeCustomerModal?: () => void;
}

const POSHeaderFields: React.FC<Props> = ({
  form,
  formErrors,

  branchDropdown,
  canPickBranch,
  customersDropdown,
  allowedDocumentTypes,

  updateField,

  handlerGenerateSale,
  handlerResetSaleFormOnly,
  handlerUpdateSaleHeader,

  isSubmitting,

  reloadCustomersDropdown,
  saveCustomerQuick,

  isCreditNote = false,

  showCustomerModal = false,

  openCustomerModal,

  closeCustomerModal,
}) => {
  return (
    <div className="flex flex-col gap-4">
      {/* ===================================================== */}
      {/* 🔹 POS Toolbar */}
      {/* ===================================================== */}
      <div
        className="
    flex
    flex-wrap
    items-end
    gap-3
  "
      >
        {/* ===================================================== */}
        {/* 🔹 Documento */}
        {/* ===================================================== */}
        <div className="min-w-[220px] flex-1 xl:max-w-[260px]">
          <POSSelectField
            label="Documento"
            name="documentType"
            iconKey="file"
            value={form.documentType?.id || ''}
            options={allowedDocumentTypes.map((doc) => ({
              label: doc.name,
              value: String(doc.id),
            }))}
            onChange={(e) =>
              updateField('documentType', {
                id: Number(e.target.value),
                name: e.target.options[e.target.selectedIndex].text,
              })
            }
            error={formErrors.documentType}
          />
        </div>

        {/* ===================================================== */}
        {/* 🔹 Sucursal (solo ADMIN/SUPPORT/ACCOUNTANT) */}
        {/* ===================================================== */}
        {canPickBranch && (
          <div className="min-w-[220px] flex-1 xl:max-w-[260px]">
            <POSSelectField
              label="Sucursal"
              name="branch"
              iconKey="building"
              value={form.branch?.id || ''}
              options={branchDropdown.map((branch) => ({
                label: branch.name,
                value: String(branch.id),
              }))}
              onChange={(e) =>
                updateField('branch', {
                  id: Number(e.target.value),
                  name: e.target.options[e.target.selectedIndex].text,
                })
              }
            />
          </div>
        )}

        {/* ===================================================== */}
        {/* 🔹 Cliente */}
        {/* ===================================================== */}
        <div className="min-w-[320px] flex-[2]">
          <POSCustomerField
          options={customersDropdown}
          selectedValue={form?.customer?.id || null}
          onSelect={(option) => updateField('customer', option)}
          onReload={reloadCustomersDropdown}
          onCustomerCreated={saveCustomerQuick}
          showCustomerModal={showCustomerModal}
          openCustomerModal={openCustomerModal}
          closeCustomerModal={closeCustomerModal}
        />
        </div>

        {/* ===================================================== */}
        {/* 🔹 Fecha */}
        {/* ===================================================== */}
        <div className="w-full sm:w-[180px]">
          <POSDateField
            label="Fecha"
            name="saleDate"
            value={form.saleDate}
            disabled
            onChange={(date) => updateField('saleDate', date)}
            error={formErrors.saleDate}
          />
        </div>

        {/* ===================================================== */}
        {/* 🔹 Acciones */}
        {/* ===================================================== */}
        <div
          className="
          ml-auto

          flex
          items-end
          gap-2
        "
        >
          {/* 🔴 Reset */}
          <POSToolbarButton
            icon="trash"
            variant="danger"
            title="Limpiar venta"
            onClick={handlerResetSaleFormOnly}
            disabled={isSubmitting}
          />

          {/* 🟢 Save / Update */}
          <POSToolbarButton
            icon={form.id ? 'edit' : 'save'}
            variant={form.id ? 'info' : 'success'}
            disabled={isSubmitting}
            loading={isSubmitting}
            title={form.id ? 'Actualizar venta' : 'Guardar venta'}
            onClick={() =>
              form.id
                ? handlerUpdateSaleHeader(form, form.id)
                : handlerGenerateSale(form)
            }
          />
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Estado */}
      {/* ===================================================== */}
      {form.id && (
        <div
          className="
            flex
            items-center
            justify-between

            rounded-xl

            border
            border-blue-100

            bg-blue-50

            px-4
            py-2

            text-sm

            dark:border-blue-900
            dark:bg-blue-950/30
          "
        >
          <div
            className="
              flex
              items-center
              gap-2

              text-blue-700

              dark:text-blue-300
            "
          >
            <HelpCircle className="h-4 w-4" />

            <span>Encabezado guardado correctamente</span>
          </div>

          <span
            className="
              font-semibold
              text-blue-800

              dark:text-blue-200
            "
          >
            Venta #{form.id}
          </span>
        </div>
      )}

      {isCreditNote && form.id && <POSCreditNoteInfo />}
    </div>
  );
};

export default POSHeaderFields;
